import { UserResponse } from '@/api/Identity/Types/UserResponse'
import { Button } from '@/components/ui/button'
import { NameDto } from 'api/Common/Types'
import { MultiSelect } from 'components/Select'
import { FilterDescriptor } from 'store/grid'
import { isEmpty } from 'utils/is-empty'

export type SelectAssignModalOpenEvent = { filterId?: string; value: boolean }

export const SelectAssigneeFilter = ({
  filter,
  onFilterChange,
  onAssignModalOpen,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onAssignModalOpen: (event: SelectAssignModalOpenEvent) => void
}) => {
  const assigneeSelected: UserResponse[] = filter?.value ?? []
  const selectValues = filter?.value?.map((assignee: NameDto) => assignee.id) ?? []
  const selectedAssigneeOptions = assigneeSelected.map((assignee) => ({
    value: assignee.id,
    label: assignee.name,
  }))

  if (isEmpty(selectValues)) {
    return (
      <Button
        size='sm'
        variant='outline'
        onClick={() => onAssignModalOpen({ filterId: filter.id, value: true })}
      >
        Choose Assignee
      </Button>
    )
  }

  return (
    <MultiSelect
      className='w-full max-w-xs'
      value={selectValues}
      options={selectedAssigneeOptions}
      showDropdown={false}
      onFocus={() => onAssignModalOpen({ filterId: filter.id, value: true })}
      onChange={(values: Array<string | number>) => {
        const assigneeState = assigneeSelected.filter((assignee) => values.includes(assignee.id))

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, filterId: filter.id, value: assigneeState },
        })
      }}
    />
  )
}
